'use strict';

/* jshint -W098 */
angular.module('mean.projects').controller('ProjectAdminSystemController', ['$scope', 'Global', 'DocumentSevice', 'tradeCodeService', 'Projects', 'ProjectBids', 'MeanUser', 'Users', '$filter', 'ProjectTasks', 'ProjectHours', '$http', 'ProjectMaterials', 'ProjectEquipments', 'toaster', 'ngDialog', 'costTotalService', '$q', 'builderService', 'Trades', 'Builders', 'userService', 'projectBidService', 'TradeBids', 'Bids',
  function($scope, Global, DocumentSevice, tradeCodeService, Projects, ProjectBids, MeanUser, Users, $filter, ProjectTasks, ProjectHours, $http, ProjectMaterials, ProjectEquipments, toaster, ngDialog, costTotalService, $q, builderService, Trades, Builders, userService, projectBidService, TradeBids, Bids) {
    $scope.global = Global;
    $scope.package = {
      name: 'projectAdmin'
    };

    $scope.user = MeanUser.user;

    $scope.deleteHours = false;
    $scope.deleteMaterials = false;
    $scope.deleteEquipment = false;
    $scope.deleteAll = false;
    $scope.project_hours = [];
    $scope.bidToDelete = {};

    $scope.projectStructure = false;
    $scope.mainAccountId = null;
    $scope.isSyncingProgress = false;

    $scope.all_trades = tradeCodeService.getArrayStrings();

    $scope.init = function() {
        Users.query({'type': 'SystemUsersOnly'}, function(users) {
          $scope.owner_list = users;
        });
    };

    $scope.fixSpellingError = function() {
        //$scope.project_list.forEach(function(project) {
            ProjectTasks.query({
                'project_id': $scope.selectedItem._id,
                'trade': 'Lanscaping'}, function (tasks) {
                    if(tasks.length === 0) {
                        toaster.pop('success', 'Spelling Fixed');
                    }
                tasks.forEach(function(task) {
                    task.trade = 'Landscaping';
                    task.$update();
                });
            });
        //});
    };

    console.log('ProjectAdminSystemController');

    $scope.getCompanyData  = function() {
        var deferred = $q.defer();

        if(builderService.isBuilder($scope.selectedUser.username)) {
            Builders.query({'builder': $scope.selectedUser._id}, function(builders) {
                if(builders.length === 0) {
                    toaster.pop('error', 'Builders DB Entry', 
                        'Could not find a Builder Entry for selected user.  Contact Admin');
                    return;
                } else if(builders.length > 1) {
                    toaster.pop('error', 'Builders DB Entry', 
                        'Too many Builder entries.  Contact Admin');
                    return;
                }
                builders[0].company_code = userService.getCompanyCode($scope.selectedUser.username);
                builders[0].trade_code = userService.getTradeCode($scope.selectedUser.username);
                deferred.resolve(builders[0]);
            });
        } else {
            Trades.query({'main_account_id': $scope.selectedUser._id}, function(trades) {
                if(trades.length === 0) {
                    toaster.pop('error', 'Trades DB Entry', 
                        'Could not find a Trade Entry for selected user.  Contact Admin');
                    return;
                } else if(trades.length > 1) {
                    toaster.pop('error', 'Trades DB Entry', 
                        'Too many Trade entries.  Contact Admin');
                    return;
                }
                trades[0].company_code = userService.getCompanyCode($scope.selectedUser.username);
                trades[0].trade_code = userService.getTradeCode($scope.selectedUser.username);
                deferred.resolve(trades[0]);
            });
        }

        return deferred.promise;
    };

    $scope.changeOwner = function(o) {
        $scope.getCompanyData().then(function(data) {
            $scope.selectedUser.company_code = data.company_code;
            $scope.selectedUser.trade_code = data.trade_code;
            $scope.trade = data;
            $scope.mainAccountId = data.builder ? data.builder._id : data.main_account_id._id;
            Projects.query({
                  'company_code': $scope.selectedUser.company_code,
                  'trade_code': $scope.selectedUser.trade_code }
                  // 'complete': false,
                  // 'match_string': true,
                  // 'username': $scope.selectedUser.username }
                  , function(projects) {
                $scope.project_list = projects;
            });
        });
    };

    $scope.changeProject = function(p) {
        $scope.numberOfLots = $scope.selectedItem.lots.length;
        $scope.projectType = ($scope.selectedItem.project_type === 'single')? 'Single Family' : 'Multi Unit';
        $scope.project_hours = [];

        //Projects.query({'_id': $scope.selectedItem._id}, function(projects) {
            //$scope.selectedItem = projects[0];
            ProjectHours.query({'project_id': $scope.selectedItem._id}, function(project_hours) {
                ProjectMaterials.query({'project_id': $scope.selectedItem._id,
                    'submitted': true}, function(project_materials) {
                    ProjectEquipments.query({'project_id': $scope.selectedItem._id, 
                        'submitted': true}, function(project_equipment) {
                        ProjectTasks.query({'project_id': $scope.selectedItem._id}, function (tasks) {
                            $scope.tasks = tasks;
                            $scope.project_hours = project_hours;

                            var scheduled_lots = $filter('filter')($scope.selectedItem.lots, {
                                'scheduled': true}, true);

                            if(!$scope.selectedItem.plan || $scope.selectedItem.plan.length === 0) {
                                toaster.pop('error', 'Project Task Plan', 
                                    'The project plan does not exist.  Redo project');
                            } else if(scheduled_lots.length * $scope.selectedItem.plan[0].task_list.length 
                                !== tasks.length) {
                                toaster.pop('warning', 'ProjectTasks Warning',
                                    'The number of project tasks do not match what is expected.');
                            }

                            ProjectBids.query({'project_id': $scope.selectedItem._id}, function(bid_tasks) {
                                _.each(bid_tasks, function(bid) {
                                    var timestamp = bid._id.toString().substring(0,8);
                                    bid._timestamp = new Date(parseInt(timestamp, 16) * 1000);
                                });

                                $scope.bid_tasks = bid_tasks;
                            });
                        });
                    });
                });
            });
        //});

        $scope.projectStructure = false;
        DocumentSevice.query({
            type: 'checkProjectSetup',
            projectId:  $scope.selectedItem._id,
            mainAccountId: $scope.mainAccountId
        }, function (result) {
              if (result.length) {
                $scope.projectStructure = true;
              } else {
                $scope.projectStructure = false;
              }
        });
    };

    $scope.syncProjectSetup = function(pObj) {
        console.log('pObj', pObj);
        $scope.isSyncingProgress = true;
        Bids.query({'project_id': pObj._id}, function(bids) {
            if(bids.length !== 1) {
                toaster.pop('error', 'Error found', 'Something wrong')
                $scope.isSyncingProgress = false;
                return;
            }
            DocumentSevice.query({
                type: 'checkBidSetup',
                bidId: bids[0]._id,
                mainAccountId: $scope.mainAccountId
              }, function (result) {
                  if (result.length) {
                    $scope.projectStructure = false;   
                    DocumentSevice.query({
                        type: 'syncProjectSetup',
                        projectId: pObj._id,
                        mainAccountId: $scope.mainAccountId
                        }, function (result) {
                        $scope.projectStructure = true;
                    }, function(error) {
                        $scope.isSyncingProgress = false;
                        toaster.pop('error', 'Error found', error.data.error)
                    });
                  } else {
                    DocumentSevice.query({
                        type: 'syncBidSetup',
                        bidId: bids[0]._id,
                        mainAccountId: $scope.mainAccountId
                        }, function (result) {
                        
                            $scope.projectStructure = false;

                            DocumentSevice.query({
                                type: 'syncProjectSetup',
                                projectId: pObj._id,
                                mainAccountId: $scope.mainAccountId
                              }, function (result) {
                                $scope.projectStructure = true;
                                $scope.isSyncingProgress = false;
                            }, function(error) {
                                $scope.isSyncingProgress = false;
                                toaster.pop('error', 'Error found', error.data.error)
                            });
                         
                    }, function(error) {
                        $scope.isSyncingProgress = false;
                        toaster.pop('error', 'Error found', error.data.error)
                    });
                  }
            });
        });
        
    }

    $scope.submit = function() {
        if($scope.deleteAll) {
            $scope.removeAllData();
        } else {
            if($scope.deleteHours) {
                $scope.removeHours();
            }

            if($scope.deleteMaterials) {
                $scope.removeMaterials();
            }

            if($scope.deleteEquipment) {
                $scope.removeEquipment();
            }
        }

        $scope.selectedItem.$delete(function(success) {
            var idx = $scope.project_list.indexOf($scope.selectedItem);
            $scope.project_list.splice(idx, 1);

            $scope.selectedItem = {};
            toaster.pop('success', 'Database Removal', 'All associated Project data has been removed.');
        });
    };

    $scope.submitOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Import Project Data!</h2>' +
                '<p>This will remove all data associated with this project.</p>' +
                '<p>This operation is not reversable and all data associated with the project ' +
                'will be removed.  This will include project task tracking and hours assoicated' +
                'with this project.  If unsure, please do not select yes.  ' +
                '<p>Are you sure you want to delete this project? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.submit();
        }, function (value) {
            //Do something
            //console.log('in the do something section');
        });
    };

    $scope.migrateProjectRecords = function() {
        var trade = $filter('filter')($scope.selectedItem.trades, {'name': $scope.trade.trade}, true);

        if(trade.length != 1) {
            toaster.pop('error', 'Problem Finding Trade');
            return;
        }

        ProjectMaterials.query({
            'trade': $scope.trade.trade,
            'project_id': $scope.selectedItem._id }, function(results) {
            results.forEach(function (report) {
                var needs_update = false;
                if(!report.invoice_date) {
                    needs_update = true;
                    report.invoice_date = report.delivery_date;
                }
                if(!report.invoice_total) {
                    needs_update = true;

                    if(report.actual_total) {
                        report.invoice_total = report.actual_total;
                    } else {
                        report.actual_total = 0;
                        var bid_trade = $filter('filter')($scope.selectedItem.trades, {'name': $scope.trade.trade}, true);
                        if(bid_trade.length != 1) {
                            toaster.pop('error', 'Problem Getting The Trade');
                        } else {
                            _.each(report.materials, function(mat) {
                                if(!mat.total) {
                                    mat.sub_total = mat.quantity * mat.price_per_order;
                                    mat.sales_tax = mat.sub_total * bid_trade[0].company_factors.sales_tax;
                                    mat.total += mat.sub_total + mat.sales_tax +
                                        (mat.delivery_price * mat.quantity);
                                }

                                report.actual_total += mat.total;
                            });

                            report.invoice_total = report.actual_total;
                        }
                    }
                }

                var diff = report.invoice_total - report.actual_total;

                if(diff > 0.01) {
                    console.log('Found diff (' + diff + ') for ' + report.task_name + ' task_code ' + report.task_code);
                    needs_update = true;
                    var each_total = diff / report.lots.length;
                    var each_subtot = each_total / (1 + trade[0].company_factors.sales_tax);
                    var each_tax = each_subtot * trade[0].company_factors.sales_tax;
                    console.log('each total: ' + each_total);

                    var inlist = $filter('filter')(report.materials, {
                        'name': 'A.C.E. System Added Material',
                        'description': 'Material added by system to adjust Invoice Total costs' }, true);

                    if(inlist.length > 0) {
                        console.log('in list');
                        _.each(inlist, function(mat) {
                            mat.total = each_total;
                            mat.sales_tax = each_tax;
                            mat.sub_total = each_subtot;
                            mat.price_per_order = each_subtot;
                        });
                    } else {
                        var project_lots = $scope.selectedItem.lots;
                        _.each(report.lots, function(lot) {
                            var plan = null;

                            for(var i=0; i<project_lots.length; i++) {
                                if(project_lots[i].number == lot.item && 
                                    project_lots[i].phase == report.phase) {
                                    plan = project_lots[i].plan;
                                    break;
                                }
                            }

                            if(plan) {
                                report.materials.push({
                                    bid_quantity: 0,
                                    color_code: '',
                                    delivery_price: 0,
                                    foreman_note: '',
                                    lot: lot.item,
                                    name: 'A.C.E. System Added Material',
                                    description: 'Material added by system to adjust Invoice Total costs',
                                    plan_code: plan,
                                    price_per_order: each_subtot,
                                    quantity: 1,
                                    sales_tax: each_tax,
                                    sub_total: each_subtot,
                                    total: each_total
                                });
                            } else {
                                console.log('Could not find phase/lot ' + report.phase + 
                                    '/' + lot.item + ' in the projects lot list. Adding material to list with no plan information.');
                                report.materials.push({
                                    bid_quantity: 0,
                                    color_code: '',
                                    delivery_price: 0,
                                    foreman_note: '',
                                    lot: lot.item,
                                    name: 'A.C.E. System Added Material',
                                    description: 'Material added by system to adjust Invoice Total costs',
                                    //plan_code: plan,
                                    price_per_order: each_subtot,
                                    quantity: 1,
                                    sales_tax: each_tax,
                                    sub_total: each_subtot,
                                    total: each_total
                                });
                            }
                        });
                    }
                }

                if(needs_update) {
                    report.$update(function(success) {
                        toaster.pop('success', 'Material Report Updated',
                            'Updated ' + success.phase + ' for supplier ' + success.supplier);
                    }, function(error) {
                        toaster.pop('error', 'Material Report Update Error',
                            'Problem updating ' + success.phase + ' for supplier ' + success.supplier);
                    })
                }
            });
        });

        //trade[0].company_factors.equipment 
        ProjectEquipments.query({
            'trade': $scope.trade.trade,
            'project_id': $scope.selectedItem._id }, function(results) {
            results.forEach(function (report) {
                var needs_update = false;
                if(!report.invoice_date) {
                    needs_update = true;
                    report.invoice_date = report.delivery_date;
                }
                if(!report.invoice_total) {
                    needs_update = true;

                    if(report.actual_total) {
                        report.invoice_total = report.actual_total;
                    } else {
                        report.actual_total = 0;
                        var bid_trade = $filter('filter')($scope.selectedItem.trades, {'name': $scope.trade.trade}, true);
                        if(bid_trade.length != 1) {
                            toaster.pop('error', 'Problem Getting The Trade');
                        } else {
                            _.each(report.equipment, function(mat) {
                                if(!mat.total) {
                                    mat.sub_total = mat.quantity * mat.price_per_order;
                                    mat.sales_tax = mat.sub_total * bid_trade[0].company_factors.equipment_tax;
                                    mat.total += mat.sub_total + mat.sales_tax +
                                        (mat.delivery_price * mat.quantity);
                                }

                                report.actual_total += mat.total;
                            });

                            report.invoice_total = report.actual_total;
                        }
                    }
                }

                var diff = report.invoice_total - report.actual_total;

                if(diff > 0.01) {
                    console.log('Found diff (' + diff + ') for ' + report.task_name + ' task_code ' + report.task_code);
                    needs_update = true;
                    var each_total = diff / report.lots.length;
                    var each_subtot = each_total / (1 + trade[0].company_factors.equipment);
                    var each_tax = each_subtot * trade[0].company_factors.equipment;
                    console.log('each total: ' + each_total);

                    var inlist = $filter('filter')(report.equipment, {
                        'name': 'A.C.E. System Added Equipment',
                        'description': 'Equipment added by system to adjust Invoice Total costs' }, true);

                    if(inlist.length > 0) {
                        console.log('in list');
                        _.each(inlist, function(eq) {
                            eq.total = each_total;
                            eq.equipment_tax = each_tax;
                            eq.sub_total = each_subtot;
                            eq.price_per_order = each_subtot;
                        });
                    } else {
                        var project_lots = $scope.selectedItem.lots;
                        _.each(report.lots, function(lot) {
                            var plan = null;

                            for(var i=0; i<project_lots.length; i++) {
                                if(project_lots[i].number == lot.item && 
                                    project_lots[i].phase == report.phase) {
                                    plan = project_lots[i].plan;
                                    break;
                                }
                            }

                            if(plan) {
                                report.equipment.push({
                                    bid_quantity: 0,
                                    color_code: '',
                                    delivery_price: 0,
                                    foreman_note: '',
                                    lot: lot.item,
                                    name: 'A.C.E. System Added Equipment',
                                    description: 'Equipment added by system to adjust Invoice Total costs',
                                    plan_code: plan,
                                    price_per_order: each_subtot,
                                    quantity: 1,
                                    equipment_tax: each_tax,
                                    sub_total: each_subtot,
                                    total: each_total
                                });
                            } else {
                                console.log('Could not find phase/lot ' + report.phase + 
                                    '/' + lot.item + ' in the projects lot list. Adding material to list with no plan information.');
                                report.equipment.push({
                                    bid_quantity: 0,
                                    color_code: '',
                                    delivery_price: 0,
                                    foreman_note: '',
                                    lot: lot.item,
                                    name: 'A.C.E. System Added Equipment',
                                    description: 'Equipment added by system to adjust Invoice Total costs',
                                    //plan_code: plan,
                                    price_per_order: each_subtot,
                                    quantity: 1,
                                    equipment_tax: each_tax,
                                    sub_total: each_subtot,
                                    total: each_total
                                });
                            }
                        });
                    }
                }

                if(needs_update) {
                    report.$update(function(success) {
                        toaster.pop('success', 'Equipment Report Updated',
                            'Updated ' + success.phase + ' for supplier ' + success.supplier);
                    }, function(error) {
                        toaster.pop('error', 'Equipment Report Update Error',
                            'Problem updating ' + success.phase + ' for supplier ' + success.supplier);
                    });
                }
            });
        });
    };

    $scope.updateHours = function() {
        ProjectHours.query({
            'project_id': $scope.selectedItem._id}, function(hours) {

            hours.forEach(function(hour) {
                hour.pay_total = costTotalService.getTotal(hour);
                hour.$update();
            });
        });
    }

    $scope.submitHoursOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Update Total Hours Data!</h2>' +
                '<p>This will update the total hours for this project.</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.updateHours();
        }, function (value) {
            //Do something
            //console.log('in the do something section');
        });
    };

    $scope.removeAllData = function() {
        ProjectBids.query({
            'project_id': $scope.selectedItem._id}, function(items) {

            items.forEach(function(item) {
                item.$delete();
            });
        });

        ProjectTasks.query({
            'project_id': $scope.selectedItem._id}, function(items) {

            items.forEach(function(item) {
                item.$delete();
            });
        });

        $scope.removeHours();
        $scope.removeMaterials();
        $scope.removeEquipment();
    };

    $scope.removeHours = function() {
        ProjectHours.query({
            'project_id': $scope.selectedItem._id}, function(hours) {

            hours.forEach(function(hour) {
                hour.$delete();
            });
        });

        // I'm leaving this here because i'd like to come back to it.
        // Need to figure out bulk deletes.
        // var ids = [];

        // for(var i=0; i<$scope.project_hours.length; i++) {
        //     ids.push($scope.project_hours[i]._id);
        // }
        // ProjectHours.bulkDelete($scope.project_hours, function(results) {
        //     console.log(results);
        // });

        // $http({
        //     url:'/api/projectHours',
        //     method: 'DELETE',
        //     data: {ids: $scope.project_hours},
        //     headers: {"Content-Type": "application/json;charset=utf-8"}
        // }).then(function(res) {
        //     console.log(res.data);
        // }, function(error) {
        //     console.log(error);
        // });

    };

    $scope.removeMaterials = function() {
        ProjectMaterials.query({
            'project_id': $scope.selectedItem._id}, function(items) {

            items.forEach(function(item) {
                item.$delete();
            });
        });
    };

    $scope.removeEquipment = function() {
        ProjectEquipments.query({
            'project_id': $scope.selectedItem._id}, function(items) {

            items.forEach(function(item) {
                item.$delete();
            });
        });
    };

    $scope.editTaskData = function(item) {
        $scope.taskToEdit = item;
        $scope.backuptask = angular.copy(item);
    };

    $scope.cancelTaskEdits = function() {
        var idx = $scope.tasks.indexOf($scope.taskToEdit);

        if(idx !== -1)
          $scope.tasks[idx] = $scope.backuptask;
    };

    $scope.acceptTaskEdits = function() {
        var idx = $scope.tasks.indexOf($scope.taskToEdit);
        $scope.taskToEdit.$update(function(success) {
            $scope.tasks[idx] = success;
            toaster.pop('success', 'Task Updated');
        }, function(error) {
            $scope.tasks[idx] = $scope.backuptask;
            toaster.pop('error', 'Task DB Error', error);
        });
    };

    $scope.hasHours = function(task) {
        var items = $filter('filter')($scope.project_hours, {'project_task_id': task._id}, true);
        return items.length > 0;
    };

    $scope.setTaskHoursData = function(task) {
        $scope.task_hours = $filter('filter')($scope.project_hours, {'project_task_id': task._id}, true);
    };

    $scope.setTaskToRemove = function(item) {
        $scope.taskToRemove = item;
    };

    $scope.removeProjectTask = function() {
        var idx = $scope.tasks.indexOf($scope.taskToRemove);

        if(idx !== -1) {
            $scope.tasks[idx].$delete(function(success) {
                $scope.tasks.splice(idx, 1);
                toaster.pop('success', 'Task Removed');
            }, function(error) {
                toaster.pop('error', 'Task Removal Error', error);
            })
        } else {
            toaster.pop('error', 'Task Retrieval', 'Problem getting the task from the list');
        }
        $scope.taskToRemove = {};
    };

    $scope.editBidData = function(item) {
        $scope.bidToEdit = item;
        $scope.backupbid = angular.copy(item);
    };

    $scope.cancelBidEdits = function() {
        var idx = $scope.bid_tasks.indexOf($scope.bidToEdit);

        if(idx !== -1)
          $scope.bid_tasks[idx] = $scope.backupbid;
    };

    $scope.acceptBidEdits = function() {
        var idx = $scope.bid_tasks.indexOf($scope.bidToEdit);

        $scope.bidToEdit.$update(function(success) {
            $scope.bid_tasks[idx] = success;
            toaster.pop('success', 'Task Updated');
        }, function(error) {
            $scope.bid_tasks[idx] = $scope.backupbid;
            toaster.pop('error', 'Task DB Error', error);
        });
    };

    $scope.getTradeRevisions = function(item, rev) {
        var trade = $filter('filter')($scope.selectedItem.trades, {'name': item.trade}, true)[0];

        // if(!$scope.revPushed) {
        //     var curr = {
        //         number: (trade.revisions.length + 1),
        //     }
        //     trade.revisions.push(curr);
        //     $scope.revPushed = true;
        // }

        return trade.revisions;
    };

    $scope.changeTradeRevision = function(lot, oldVal, newVal) {
        console.log($scope);
        oldVal.revision = newVal.number;
        $scope.selectedItem.$update(function(success) {
            //var trade = $filter('filter')(success.trades, {'name': oldVal.trade}, true)[0];
            //trade.revisions[trade.revisions.length].number = trade.revisions.length + 1;
            $scope.selectedItem = success;
            toaster.pop('success', 'Project Updated');
        }, function(error) {
            toaster.pop('error', 'Error Updating Project', error);
        })
    };

    $scope.setRevisionData = function(trade, rev) {
        $scope.selected_trade = $filter('filter')($scope.selectedItem.trades, {'_id': trade._id}, true)[0];
        $scope.selected_revision = $filter('filter')($scope.selected_trade.revisions, {'number': rev.number}, true)[0];

        $scope.affected_lots = [];
        _.each($scope.selectedItem.lots, function(lot) {
            var my_rev = $filter('filter')(lot.revisions, {'trade': trade.name}, true)[0];
            if(my_rev.revision >= rev.number) {
                $scope.affected_lots.push(lot);
            }
        });
    };

    $scope.acceptRemoveRevision = function() {
        console.log($scope);
        console.log($scope.selected_revision);
        _.remove($scope.selected_trade.revisions, function(rev) {
            return rev.number === $scope.selected_revision.number;
        });

        var removed = false;
        for(var i=0; i<$scope.selected_trade.revisions.length; i++) {
            var rev = $scope.selected_trade.revisions[i];
            if(removed) {
                rev.number = i+1;
            }

            if(!removed && rev.number === $scope.selected_revision.number) {
                $scope.selected_trade.revisions.splice(i, 1);
                --i;
                removed = true;
            }
        }

        $scope.selectedItem.$update(function(success) {
            // var trade = $filter('filter')(success.trades, {'name': oldVal.trade}, true)[0];
            // trade.revisions[trade.revisions.length].number = trade.revisions.length + 1;
            $scope.selectedItem = success;
            toaster.pop('success', 'Project Updated');
        }, function(error) {
            toaster.pop('error', 'Error Updating Project', error);
        });
    };

    $scope.cancelRemoveRevision = function() {
        console.log('I dont think i need to do anything here');
    };

    $scope.editNumber = function (item) {
        item.numberEditing = true;
    };

    $scope.doneNumberEditing = function (item, val) {
        if(!item.numberEditing) return;

        item.number = val;

        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success
            toaster.pop('success', 'Project Updated');
        }, function(error) {
            toaster.pop('error', 'Project Update Error', error);
        });

        item.numberEditing = false;
    };

    $scope.setBidRecordData = function (item) {
        $scope.bidToDelete = item;
    };

    $scope.removeBidRecord = function () {
        var idx = $scope.bid_tasks.indexOf($scope.bidToDelete);
        $scope.bidToDelete.$delete(function(success) {
            if(idx !== -1) {
                $scope.bid_tasks.splice(idx, 1);
            }
            toaster.pop('success', 'Bid Record Removed');
        }, function(error) {
            toaster.pop('error', 'Bid Record Error', error);
        })
    };

    $scope.editPlanCodeData = function(plan, item) {
        $scope.planCodeToEdit = {
            plan: plan,
            item: item
        };
    };

    $scope.setPlanCodeData = function(plan, item) {
        $scope.planCodeToDelete = {
            plan: plan,
            item: item
        };
    };

    $scope.removePlanCode = function() {
        console.log($scope);
        var trade = $filter('filter')($scope.selectedItem.trades, {
            'name': $scope.planCodeToDelete.item.trade}, true)[0];
        if(trade.revisions.length < $scope.planCodeToDelete.item.revision) {
            toaster.pop('error', 'Cannot Remove Revision', 'This is the current revision and cannot be removed');
            return;
        }

        var idx = $scope.planCodeToDelete.plan.trade_totals.indexOf($scope.planCodeToDelete.item);
        if(idx !== -1) {
            $scope.planCodeToDelete.plan.trade_totals.splice(idx, 1);
        }

        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success
            toaster.pop('success', 'Project Updated');
        }, function(error) {
            toaster.pop('error', 'Project Update Error', error);
        });
    };

    $scope.cancelPlanCode = function() {
        console.log($scope);
    };

    $scope.acceptPlanCodeEdits = function() {
        console.log($scope);
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success
            toaster.pop('success', 'Project Updated');
        }, function(error) {
            toaster.pop('error', 'Project Update Error', error);
        });
    };

    $scope.cancelPlanCodeEdits = function() {
        console.log($scope);
    };

    $scope.fixThisRevision = function(plan, revision, removeBids) {
        if(!plan) {
            console.log('plan is not set');
            return;
        }

        if(!revision) {
            revision = 0;
        }

        ngDialog.openConfirm({
            template: 
                '<h2>Regenerate ProjectBids Confirm</h2>' +
                '<p>This will regenerate the projectBid records for this plan/revision.</p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            Bids.query({'project_id': $scope.selectedItem._id}, function(bids) {
                if(bids.length !== 1) {
                    console.log('something is not right');
                    return;
                }

                var my_bid = bids[0].bidding_trades[0];
                TradeBids.query({'_id': my_bid._id}, function(tradeBids) {
                    if(tradeBids.length !== 1) {
                        console.log('something in tradeBids is not right');
                        return;
                    }

                    projectBidService.buildProjectBidsFromPlanAndVersion(
                        $scope.selectedItem._id, tradeBids[0], plan, revision, removeBids);
                });
            });
        });
    };

    $scope.addMissingRevisions = function(trade) {
        Bids.query({'project_id': $scope.selectedItem._id}, function(bids) {
            if(bids.length !== 1) {
                console.log('something is not right');
                return;
            }

            var my_bid = bids[0].bidding_trades[0];
            TradeBids.query({'_id': my_bid._id}, function(tradeBids) {
                if(tradeBids.length !== 1) {
                    console.log('something in tradeBids is not right');
                    return;
                }

                console.log(tradeBids[0]);

                _.each(tradeBids[0].revisions, function(revision) {
                    revision.company_factors = revision.costs;
                });

                trade.revisions = tradeBids[0].revisions;

                console.log($scope);

                $scope.selectedItem.$update(function(success) {
                    $scope.selectedItem = success;
                    toaster.pop('success', 'Project Updated');
                }, function(error) {
                    toaster.pop('error', 'Project Update Error', error);
                });
            });
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectAdminSystem.js